import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Typography } from '@mui/material';
var AuthCallback = function () {
    var navigate = useNavigate();
    var code = useParams().code;
    useEffect(function () {
        var handleCallback = function () {
            var url = new URL(window.location.href);
            var accessToken = url.searchParams.get('access_token');
            var refreshToken = url.searchParams.get('refresh_token');
            //@ts-ignore
            axios.post("".concat(process.env.REACT_APP_API_URL, "?action=zoom_update_token_exchange_code&code=").concat(code), {
                __at: accessToken || '',
                __rt: refreshToken || ''
            })
                .then(function (res) {
                var data = res.data;
                window.location.href = '/auth-success';
            })
                .catch(function (e) { return console.log(e); });
        };
        handleCallback();
    }, [navigate]);
    return (_jsxs(Box, { sx: { height: '100vh', width: '100%', pt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }, children: [_jsx(Box, { sx: { height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(CircularProgress, { size: 80 }) }), _jsx(Typography, { sx: { my: 1 }, variant: 'h6', children: "Authentication in progress.. Please wait.." })] }));
};
export default AuthCallback;
